/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileDataSchema = z.object({
	workHistory: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
	education: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
	licenses: z.array(
		z.object({ id: z.string(), contents: z.string(), createdAt: z.iso.datetime(), updatedAt: z.iso.datetime() }),
	),
})

export type CandidateProfileDataSchema = z.infer<typeof candidateProfileDataSchema>
